/**
 * Formats days remaining for subscription display
 * - Less than 1 month: "15 days"
 * - 1 month or more: "2 months and 4 days"
 */
export function formatDaysRemaining(endDate: string | Date): string {
  const end = typeof endDate === 'string' ? new Date(endDate) : endDate;
  const now = new Date();
  
  // Set both dates to start of day for accurate calculation
  const endDateOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  const diffTime = endDateOnly.getTime() - nowDateOnly.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 0) {
    return '0 days';
  }
  
  if (diffDays < 30) {
    return `${diffDays} ${diffDays === 1 ? 'day' : 'days'}`;
  }
  
  // Calculate months and remaining days
  const months = Math.floor(diffDays / 30);
  const remainingDays = diffDays % 30;
  
  const monthText = months === 1 ? 'month' : 'months';
  
  if (remainingDays === 0) {
    return `${months} ${monthText}`;
  }
  
  const daysText = remainingDays === 1 ? 'day' : 'days';
  return `${months} ${monthText} and ${remainingDays} ${daysText}`;
}

/**
 * Gets days remaining as a number
 */
export function getDaysRemaining(endDate: string | Date): number {
  const end = typeof endDate === 'string' ? new Date(endDate) : endDate;
  const now = new Date();
  
  const endDateOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  const diffTime = endDateOnly.getTime() - nowDateOnly.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

